import {enableProdMode} from '@angular/core';

import {environment} from './environments/environment';
// sentry
import {bootstrapApplication, enableDebugTools} from "@angular/platform-browser";
import {ENDPOINT_URL_PROVIDER} from "./config/endpoint.config";
import {DEFAULT_HEADERS_PROVIDER} from "./config/authorization.config";
import {initSentry} from "./config/sentry.config";
import {initSyncfusion} from "./config/syncfusion.config";
import {APP_CONFIG} from "./app/app.config";
import {AppComponent} from "./app/app.component";
import '@tailwindplus/elements';

const providers = [
  ENDPOINT_URL_PROVIDER, DEFAULT_HEADERS_PROVIDER
];

if (environment.production) enableProdMode();

initSentry();
initSyncfusion();

bootstrapApplication(AppComponent, APP_CONFIG)
  .then(appRef => {
    if (environment.production) return;

    const compRef = appRef.components[0];
    enableDebugTools(compRef);
  }).catch(err => console.error(err));
